import { createSlice } from "@reduxjs/toolkit";
import {
  AllVideoCollectionThunk,
  GetSingleVideoCollectionThunk,
  AddVideoCollectionThunk,
  UpdateVideoCollectionThunk,
  DeleteVideoCollectionThunk,
} from "./thunk";

const initialState = {
  videocollection: [],
  singlevideocollection: null,
  loading: false,
  error: null,
  successMessage: null,
};

const videocollectionsSlice = createSlice({
  name: "videocollection",
  initialState,
  reducers: {
    clearReviewState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* -------------------- ALL REVIEWS -------------------- */
      .addCase(AllVideoCollectionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllVideoCollectionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.videocollection = action.payload?.data || [];
      })
      .addCase(AllVideoCollectionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- SINGLE REVIEW -------------------- */
      .addCase(GetSingleVideoCollectionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleVideoCollectionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singlevideocollection = action.payload?.data || null;
      })
      .addCase(GetSingleVideoCollectionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD REVIEW -------------------- */
      .addCase(AddVideoCollectionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddVideoCollectionThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Review added successfully!";
      })
      .addCase(AddVideoCollectionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- UPDATE REVIEW -------------------- */
      .addCase(UpdateVideoCollectionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateVideoCollectionThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Review updated successfully!";
      })
      .addCase(UpdateVideoCollectionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE REVIEW -------------------- */
      .addCase(DeleteVideoCollectionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteVideoCollectionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.videocollection = state.videocollection.filter(
          (r) => r.uuid !== action.payload.uuid
        );
        state.successMessage =
          action.payload.message || "Review deleted successfully!";
      })
      .addCase(DeleteVideoCollectionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearReviewState } = videocollectionsSlice.actions;
export default videocollectionsSlice.reducer;
